import React from "react";
import useFinancialHealth from "./useFinancialHealth";
import { Loader } from "@/components";
import { formatAmount } from "@/lib/utils";

const FinancialHealth: React.FC = () => {
  const {
    ar,
    ap,
    arOutstanding,
    apOutstanding,
    isLoadingData,
  } = useFinancialHealth();

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6 space-y-4">
      <div>
        <h3 className="text-base font-semibold text-gray-900">
          Financial Health
        </h3>

        <p className="text-sm text-gray-500 mt-1">
          Your system maintains only A/R (Owner Bills & Collections) and A/P
          (Vendor Invoices & Payments). FY close focuses on clearing and
          validating these ledgers.
        </p>
      </div>

      {isLoadingData ? <Loader /> : 
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="border border-gray-200 rounded-lg p-5">
            <p className="text-sm font-medium text-gray-900">
              A/R <span className="text-gray-500 font-normal">(Owner)</span>
            </p>

            <p className="text-s font-medium text-gray-900 mt-2 mb-4">
              Bills vs Collections
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="border border-gray-200 rounded-md p-3">
                <p className="text-xs text-gray-500 mb-1">Billed</p>
                <p className="font-semibold text-gray-900">
                  US {formatAmount(ar.billed)}
                </p>
              </div>

              <div className="border border-gray-200 rounded-md p-3">
                <p className="text-xs text-gray-500 mb-1">Collected</p>
                <p className="font-semibold text-gray-900">
                  US {formatAmount(ar.collected)}
                </p>
              </div>

              <div className="bg-blue-100 border border-blue-200 rounded-md p-3">
                <p className="text-xs text-primary mb-1">Outstanding</p>
                <p className="font-semibold text-primary">
                  US {formatAmount(arOutstanding)}
                </p>
              </div>
            </div>
          </div>

          <div className="border border-gray-200 rounded-lg p-5">
            <p className="text-sm font-medium text-gray-900">
              A/P <span className="text-gray-500 font-normal">(Vendor)</span>
            </p>

            <p className="text-s font-medium text-gray-900 mt-2 mb-4">
              Invoices vs Payments
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="border border-gray-200 rounded-md p-3">
                <p className="text-xs text-gray-500 mb-1">Invoice</p>
                <p className="font-semibold text-gray-900">
                  US {formatAmount(ap.billed)}
                </p>
              </div>

              <div className="border border-gray-200 rounded-md p-3">
                <p className="text-xs text-gray-500 mb-1">Payments</p>
                <p className="font-semibold text-gray-900">
                  US {formatAmount(ap.collected)}
                </p>
              </div>

              <div className="bg-blue-100 border border-blue-200 rounded-md p-3">
                <p className="text-xs text-primary mb-1">Outstanding</p>
                <p className="font-semibold text-primary">
                  US {formatAmount(apOutstanding)}
                </p>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default FinancialHealth;